export default {
    themeList: [],
    currentSelectedTheme: {},
    currentSelectedThemeId: '',
    loading: false,
}
